/**
 * 入力画面（/input）の共通の定数と純関数。削除したアリーナ（Issue #474）から生き残った部分だけ（Issue #494）。
 * - プレイヤーの色（盤・行の枠の色）: **試合のプレイヤーに登録した色（players.color）**をページが context で配り、部品は `usePlayerColors()` で受ける
 *   （以前は P1 = 黄 / P2 = 桃の決め打ちで、演出の HUD や登録の別ウィンドウと色が違っていた）
 * - フェイズの表記・カードの縦横比
 * フィールド動画の切り抜き（fieldCrop）は同梱マットの寸法から出すので `utils/defaultOverlayZones.js`（Issue #496）
 */
import { createContext, useContext } from 'react';
import { DEFAULT_PLAYER_COLORS } from '../../utils/gameInfo';

/** 枠の色: 試合のプレイヤーに登録された色（players.color。GetDuelGameInfo の player_N_info.color）、無ければ既定（演出の HUD と同じ青 / 赤） */
export function playerColor(player, colors = []) {
  if (player !== 0 && player !== 1) return null;
  const c = colors?.[player];
  return /^#[0-9a-f]{6}$/i.test(c ?? '') ? c : DEFAULT_PLAYER_COLORS[player];
}

/** ページが試合のプレイヤーの色 [P1, P2] を配る（`playersFromGame(game).map((p) => p.color)`）。無ければ既定 */
const PlayerColorsContext = createContext(null);
export const PlayerColorsProvider = PlayerColorsContext.Provider;
export function usePlayerColors() {
  return useContext(PlayerColorsContext) ?? DEFAULT_PLAYER_COLORS;
}

/** フェイズの表記（core のフェイズ名 → 画面の文字） */
export const PHASE_LABEL = { draw: 'DRAW', standby: 'STANDBY', main1: 'MAIN 1', battle_start: 'BATTLE', battle_step: 'BATTLE', damage: 'BATTLE', damage_calc: 'BATTLE', battle: 'BATTLE', main2: 'MAIN 2', end: 'END' };
export const phaseLabel = (phase) => (phase ? PHASE_LABEL[phase] ?? String(phase).toUpperCase() : '');

export const CARD_ASPECT = 59 / 86;   // カードの幅 / 高さ
